export default __webpack_public_path__ + "static/media/cursor.d180a766.svg";